import zhCN from './json/bulletin.zh_CN.json';
import zhTW from './json/bulletin.zh_TW.json';
import en from './json/bulletin.en.json';
import ja from './json/bulletin.ja.json';
import ko from './json/bulletin.ko.json';
import ru from './json/bulletin.ru.json';
export default {
  zh_CN: zhCN,
  zh_TW: zhTW,
  en,
  ja,
  ko,
  ru
};
